<template>
  <div>
    <banner-logo />
    <transition name="slide" mode="out-in">
      <div v-bind:key="currentStep" class="step-card">
        <div class="step-instruction">
          <img
            v-if="currentStep == 0"
            src="../assets/icons/speaker.png"
            class="icon"
          />
          <img
            v-if="currentStep == 1"
            src="../assets/icons/tap.png"
            class="icon"
          />
          <img
            v-if="currentStep == 2"
            src="../assets/icons/phone.png"
            class="icon phone"
          />
          <div class="instruction">
            {{ cardMessage }}
          </div>
        </div>
        <div class="next-btn" v-on:click="incStep">
          {{ buttonMessage }}
        </div>
        <div v-if="isIOS && iosVersion < 13 && currentStep == 2">
          If you're not hearing anything and you're on iOS version 12 or less,
          try turning on Motion and orientation access. You can do this by going
          to Settings > Safari and enabling Motion and Orientation access.
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import BannerLogo from "./BannerLogo.vue";
import { Howl, Howler } from "howler";

export default {
  name: "HomePage",
  components: {
    BannerLogo,
  },
  data: () => ({
    currentStep: 0,
    playing: false,
    sources: [
      "https://cdn.glitch.com/1272abfd-c3bb-417e-af76-59727da0cce9%2Fmyanmarprotest.mp3?v=1612514585279",
      "https://cdn.glitch.com/1272abfd-c3bb-417e-af76-59727da0cce9%2Fprotest3.mp3?v=1612621073322",
      "https://cdn.glitch.com/1272abfd-c3bb-417e-af76-59727da0cce9%2Fprotest2.mp3?v=1612621072530",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2FInside%20the%20street.mp3?v=1613229041221",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fbells%20from%20cane%20surger%20machin.mp3?v=1613229041756",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fdifferent%20beat.mp3?v=1613229042723",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fhihat.mp3?v=1613229043720",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fhi%20hat.mp3?v=1613229044107",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fchat.mp3?v=1613229044414",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fchantting%20for%20police.mp3?v=1613229044551",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fcombind%20instrument.mp3?v=1613229045615",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fbombained2.mp3?v=1613229046031",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fthe%20military%20is%20not%20to%20kill%20citizin%20chant.mp3?v=1613229046160",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fbisskit%20box.mp3?v=1613229046207",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fbuddish%20chant%20for%20peace%20i%20supporse.mp3?v=1613229046258",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2FUp%20sound.mp3?v=1613229047201",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2FSong%20for%20Police%20man.mp3?v=1613229048598",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fwaterdrum.mp3?v=1613229048852",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fwe%20voted%20for%20NLD.mp3?v=1613229049695",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fsemms%20like%20unison%20but%20not.mp3?v=1613229050439",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2Fryth.mp3?v=1613229052235",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2FDo%20A%20Yay.mp3?v=1613229053181",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2FZOOM0032_LR.mp3?v=1613229055699",
      "https://cdn.glitch.com/87105207-d19f-4c12-9090-21e45a374f26%2FZOOM0033_LR.mp3?v=1613229057838",
    ],
    sounds: [],
    x: 0,
    y: 0,
    z: 0,
    dist: 0,
    ease: 0.05,
    volEase: 0.07,
    thresh: 200,
    vol: 0,
    realVol: 0,
    iosVersion: 0,
    seed: 0,
  }),
  methods: {
    incStep: function () {
      switch (this.currentStep) {
        case 0:
          this.currentStep++;
          break;
        case 1:
          this.currentStep++;
          if (this.isIOS && this.iosVersion > 12) {
            DeviceMotionEvent.requestPermission();
          }
          window.addEventListener("devicemotion", this.handleDeviceMotion);
          this.sounds[this.seed].play();
          break;
        case 2:
          this.sounds[this.seed].stop();
          this.seed = Math.floor(Math.random() * this.numSources);
          this.sounds[this.seed].play();
          break;
        default:
          break;
      }
    },
    handleDeviceMotion: function (e) {
      this.x = e.acceleration.x;
      this.y = e.acceleration.y;
      this.z = e.acceleration.z;
      //use acceleration to calculate the distance moved by phone
      var d = this.dist3D(this.x, this.y, this.z);
      this.dist += d - this.dist * this.ease;
      //vol is an on-off switch
      this.vol = this.dist > this.thresh ? 1 : 0;
      this.realVol += this.vol - this.realVol * this.volEase;
      this.realVol = this.value_limit(this.realVol, 0, 1);
      Howler.volume(this.realVol);
    },
    dist3D: function (x, y, z) {
      return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2) + Math.pow(z, 2));
    },
    value_limit: function (val, min, max) {
      return val < min ? min : val > max ? max : val;
    },
  },
  computed: {
    cardMessage: function () {
      switch (this.currentStep) {
        case 0:
          return "For the best experience, turn off silent mode";
        case 1:
          return "Press Start and get ready to make some noise";
        case 2:
          return "Shake your phone and protest with the people of Myanmar!";
        default:
          return "";
      }
    },
    buttonMessage: function () {
      switch (this.currentStep) {
        case 0:
          return "Next";
        case 1:
          return "Start";
        case 2:
          return "Change Sounds";
        default:
          return "";
      }
    },
    numSources: function () {
      return this.sources.length;
    },
    isIOS: function () {
      return (
        (/iPad|iPhone|iPod/.test(navigator.platform) ||
          (navigator.platform === "MacIntel" &&
            navigator.maxTouchPoints > 1)) &&
        !window.MSStream
      );
    },
  },
  mounted: function () {
    this.seed = Math.floor(Math.random() * this.numSources);
    for (var i in this.sources) {
      this.sounds.push(new Howl({ src: [this.sources[i]], loop: true }));
      Howler.volume(0);
    }
    var agent = window.navigator.userAgent;
    var start = agent.indexOf("OS");
    if (
      (agent.indexOf("iPhone") > -1 || agent.indexOf("iPad") > -1) &&
      start > -1
    ) {
      this.iosVersion = window.Number(
        agent.substr(start + 3, 3).replace("_", ".")
      );
    }
  },
};
</script>

<style>
.step-card {
  z-index: -2;
  width: 85vw;
  height: 56vh;
  margin-top: 4vh;
  background: #e04b2b;
  mix-blend-mode: hard-light;
}

.step-instruction {
  padding-top: 20vh;
  display: flex;
  justify-content: space-between;
}

.icon {
  padding: 10px;
  width: 15vh;
  height: 15vh;
  z-index: 9;
  mix-blend-mode: normal;
}
.instruction {
  font-size: 1.25em;
  color: white;
  width: 65vw;
  margin: auto;
  mix-blend-mode: normal;
}

.next-btn {
  position: relative;
  right: -45vw;
  background: #ffe500;
  border-radius: 5px;
  text-align: center;
  font-weight: 700;
  width: 30vw;
  padding: 7px 10px;
  mix-blend-mode: normal;
}

@keyframes slide-in {
  from {
    transform: translateX(200vw);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 100;
  }
}

.slide-enter-active {
  animation: slide-in 0.75s;
}

.slide-leave-active {
  transition: all 0.75s;
}

.slide-leave-to {
  transform: translateX(-100vw);
  opacity: 0;
}

@keyframes shake {
  from {
    transform: rotateZ(0);
  }
  10% {
    transform: rotateZ(10deg);
  }
  20% {
    transform: rotateZ(0deg);
  }
  30% {
    transform: rotateZ(-10deg);
  }
  40% {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(0deg);
  }
}

.phone.icon {
  animation: shake 3s infinite linear;
}
</style>